import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Document(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Document", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.6316 42H7.89474c-.50252 0-.98445-.1996-1.33978-.555C6.19962 41.0897 6 40.6078 6 40.1053V7.89474c0-.50252.19962-.98445.55496-1.33978C6.91029 6.19962 7.39222 6 7.89474 6H24.8811l7.6452 7.5032v26.6021c0 .5025-.1996.9844-.5549 1.3397-.3554.3554-.8373.555-1.3398.555Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M24.9473 6v7.5789h7.5789L24.9473 6Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.1575 14.5261H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1777-.27744-.4186-.27744-.6699 0-.2512.09981-.4922.27744-.6699.1777-.1776.4187-.2775.6699-.2775h10.4211c.2512 0 .4922.0999.6699.2775.1776.1777.2775.4187.2775.6699 0 .2513-.0999.4922-.2775.6699-.1777.1777-.4187.2775-.6699.2775Zm5.6842 4.7368H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6698 0-.2513.09981-.4923.27744-.6699.1777-.1777.4187-.2775.6699-.2775h16.1053c.2513 0 .4922.0998.6699.2775.1777.1776.2775.4186.2775.6699 0 .2512-.0998.4922-.2775.6698-.1777.1777-.4186.2775-.6699.2775Zm-2.8421 4.7369H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1777-.27744-.4186-.27744-.6699s.09981-.4922.27744-.6699c.1777-.1777.4187-.2775.6699-.2775h13.2632c.2512 0 .4922.0998.6699.2775.1776.1777.2775.4186.2775.6699s-.0999.4922-.2775.6699c-.1777.1777-.4187.2775-.6699.2775Zm-2.8421 4.7368H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6699 0-.2512.09981-.4922.27744-.6698.1777-.1777.4187-.2775.6699-.2775h10.4211c.2512 0 .4922.0998.6699.2775.1776.1776.2775.4186.2775.6698 0 .2513-.0999.4923-.2775.6699-.1777.1777-.4187.2775-.6699.2775Zm-2.8421 5.6842h-7.579c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6698 0-.2513.09981-.4923.27744-.6699.1777-.1777.4187-.2775.6699-.2775h7.579c.2512 0 .4922.0998.6699.2775.1776.1776.2774.4186.2774.6699 0 .2512-.0998.4922-.2774.6698-.1777.1777-.4187.2775-.6699.2775Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.627 16.4209c-.2641-.265-.5778-.4752-.9233-.6187-.3455-.1434-.7158-.2172-1.0899-.2172-.3741 0-.7444.0738-1.0899.2172-.3455.1435-.6592.3537-.9233.6187L23.8775 29.1061l-1.3453 5.3622 5.3621-1.3453L40.627 20.3998c.5207-.5312.8124-1.2455.8124-1.9894 0-.744-.2917-1.4582-.8124-1.9895Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Document.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Document"
};
validateTidalLicense();
export {
  Document
};
//# sourceMappingURL=Document.js.map
